import React from 'react';
import { Route, Routes } from "react-router-dom";

import DeconsolidationCreateScreen from "screens/App/CRM/Deconsolidation/DeconsolidationCreateScreen";
import DeconsolidationDetailScreen from "screens/App/CRM/Deconsolidation/DeconsolidationDetailScreen";
import DeconsolidationEditScreen from "screens/App/CRM/Deconsolidation/DeconsolidationEditScreen";
import DeconsolidationListScreen from "screens/App/CRM/Deconsolidation/DeconsolidationListScreen";

import NotFoundScreen from "screens/NotFoundScreen";

const DeconsolidationRouter = () => {
    return (
        <Routes>
            <Route path="create" element={<DeconsolidationCreateScreen />} />
            <Route path="list" element={<DeconsolidationListScreen />} />
            <Route path=":id/detail" element={<DeconsolidationDetailScreen />} />
            <Route path=":id/edit" element={<DeconsolidationEditScreen />} />
            <Route path="*" element={<NotFoundScreen />} />
        </Routes>
    );
};

export default DeconsolidationRouter;
